export const environment = {
  production: true,
  debugRoute: undefined,
  enableProductZone: false,
  displayLegal: false,
  forceLogoMobile: true,
  apiUrl: 'https://monoprix-flipbook.elpev.com/api',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts